module.exports = __webpack_public_path__ + "static/media/cover15.45fffdfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover15.png
// module id = 568
// module chunks = 0